import { Chip, ChipProps } from '@mui/material';
import { REGISTRATION_PAYMENT_LABEL, RegistrationPaymentStatus } from './registrationPayment';

const COLOR: Record<RegistrationPaymentStatus, ChipProps['color']> = {
  NOT_PAID: 'default',
  PENDING_APPROVAL: 'warning',
  APPROVED: 'success',
  REJECTED: 'error',
  REVERSED: 'warning',
};

export const RegistrationPaymentChip = ({ status, prefix = 'Registration payment' }: { status: RegistrationPaymentStatus; prefix?: string }) => (
  <Chip
    size="small"
    color={COLOR[status]}
    variant={status === 'REVERSED' || status === 'NOT_PAID' ? 'outlined' : 'filled'}
    label={`${prefix}: ${REGISTRATION_PAYMENT_LABEL[status]}`}
    data-testid="registration-payment-status"
  />
);
